// OTel `error.type` for a caught value (observability standard rule 3): the class name
// classifies the failure without carrying its message, which can quote a hint or an address.
export function errorType(e: unknown): string {
  return e instanceof Error ? e.constructor.name : 'unknown';
}
